// ReportModal.js

import React from 'react';
import Modal from 'react-modal';
import '../css/PersonRow.css'; // Stilovi za komponentu gumbe
import { FaDownload } from 'react-icons/fa'; // Import ikona

// Postavite element aplikacije za pristupačnost
Modal.setAppElement('#root'); // Promijenite '#root' prema vašem glavnom elementu aplikacije

const ReportModal = ({ isOpen, onRequestClose, onGenerateReport }) => {
  const handleDownload = (format) => {
    onGenerateReport(format);
    onRequestClose(); // Zatvorite modal nakon odabira
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal"
      overlayClassName="overlay"
    >
      <h2>Izaberi format izvještaja</h2>
      <div className="report-buttons">
        {/* Hrvatske verzije */}
        <button
          className="edit-button"
          onClick={() => handleDownload('xlsx')}
        >
          <FaDownload /> Download XLSX
        </button>
        <button
          className="edit-button"
          onClick={() => handleDownload('pdf')}
        >
          <FaDownload /> Download PDF
        </button>
        <button
          className="edit-button"
          onClick={() => handleDownload('print')}
        >
          <FaDownload /> Print
        </button>

        {/* Engleske verzije */}
        <button
          className="edit-button"
          onClick={() => handleDownload('xlsx-en')}
        >
          <FaDownload /> Download XLSX (EN)
        </button>
        <button
          className="edit-button"
          onClick={() => handleDownload('pdf-en')}
        >
          <FaDownload /> Download PDF (EN)
        </button>
        <button
          className="edit-button"
          onClick={() => handleDownload('print-en')}
        >
          <FaDownload /> Print (EN)
        </button>
      </div>
      <button onClick={onRequestClose} className="close-modal-button">
        Close
      </button>
    </Modal>
  );
};

export default ReportModal;
